import GenericSidebar from "../../../../components/Modals/genericSidebar";
import { WebEditorContext, TextLibraryContext } from "../../../../contexts";
import { useContext, useState, useEffect } from "react";
import * as Constants from "../../../../utils/constants"
import TextLibraryComponent from "./textLibraryComponent";
import { useMediaQuery } from "../../../../hooks/useMediaQuery";
import { useTranslation } from 'react-i18next';
import { resources, translations } from "../../../../translations/translationsConstants";

export default function TextLibraryOverlapSideBar() {
    const { editorFile, handleActionMenuBar, sideBarState, setSideBarState } = useContext(WebEditorContext);
    const { setSelectedEditorInsertPoint } = useContext(TextLibraryContext);
    const largeMatch = useMediaQuery('(min-width: 1024px)');
    const [open, setOpen] = useState(sideBarState === Constants.sideBarState.textLibrary && !largeMatch);
    const { t: te } = useTranslation([resources.edit]);

    useEffect(() => {
        if (largeMatch && sideBarState === Constants.sideBarState.textLibrary) {
            setOpen(false);
        }
        if (!largeMatch && sideBarState === Constants.sideBarState.textLibrary) {
            setOpen(true);
        }
    }, [largeMatch]);

    const handleOpen = (value) => {
        if (!value) {
            handleActionMenuBar({
                editorFile: editorFile,
                actionMenuBar: {
                    textLibraryState: Constants.normalState,
                },
            })
        }

        if (value) {
            setSideBarState(Constants.sideBarState.textLibrary);
        } else {
            setSideBarState(Constants.sideBarState.closed);
        }
        setSelectedEditorInsertPoint(null);
    }

    return (
        <GenericSidebar
            open={open}
            setOpen={handleOpen}
            onClose={() => handleOpen(false)}
            title={te(translations.edit.library.textLibrary)}
        >
            <TextLibraryComponent />
        </GenericSidebar>
    )
}